module.exports = __webpack_public_path__ + "static/media/close-thin.330fd1d7.svg";